import React, { useEffect } from 'react'
import "./comingsoon.scss"
import Headernew from '../landing/headernew/Headernew'

const ComingSoon = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    return (
        <>


            <div className='soon_parents'>
                 <Headernew />
                <section className="comingsoon">
                    <video
                        className="main-banner-video"
                        muted
                        playsInline
                        autoPlay
                        loop
                        width="100%"
                        id="myVideo"
                    >
                        <source src="/assets/bannervideo.mp4" type="video/mp4" />
                    </video>
                    <div className="custom-container">
                        <div className="maincontent">
                            <h2>Coming Soon</h2>
                        </div>
                    </div>
                </section>
            </div>

        </>
    )
}

export default ComingSoon
